const useImageStyles = (size, rounded) => {
  let width, height;

  switch (size) {
    case "2xl":
      width = "w-[240px]";
      height = "h-[240px]";
      break;
    case "xl":
      width = "w-20";
      height = "h-20";
      break;
    case "lg":
      width = "w-16";
      height = "h-16";
      break;
    case "md":
      width = "w-12";
      height = "h-12";
      break;
    case "sm":
    default:
      width = "w-8";
      height = "h-8";
  }

  const baseClass = ` ${width} ${height}`;

  return {
    baseClass,
  };
};

export const Image = ({
  src,
  alt,
  size = "sm",
  rounded = "sm",
  className = "",
}) => {
  const { baseClass } = useImageStyles(size);
  return (
    <img
      src={src}
      alt={alt}
      className={`${baseClass} rounded-${rounded} ${className}`}
    />
  );
};
